<template>
  <li class="list-group-item">
    <h5 class="mb-1 text-center">{{ cartItem.name }} <span v-if="cartItem.deliveryPriority" class="badge badge-pill badge-info">Delivery</span></h5>
    <div class="row no-gutters">
      <div class="col-9">
        <p class="my-2 font-size-up">
          {{ cartItem.price | currency('Bs.', 2, {
          thousandsSeparator: ".",
          decimalSeparator: ",",
          symbolOnLeft: true,
          spaceBetweenAmountAndSymbol: true
          })
          }}
          <template
            v-if="rate"
          >
            ({{ itemPriceUSD | currency('$', 2, {
            thousandsSeparator: ".",
            decimalSeparator: ",",
            symbolOnLeft: true,
            spaceBetweenAmountAndSymbol: true
            })
            }})
          </template>
        </p>
        <spinner class="my-2" :quantity="cartItem.count" :saleLimit="cartItem.saleLimit" @update="(value) => cartItem.count = value" />
        <strong class="my-2 font-size-up">
          {{ subtotal | currency('Bs.', 2, {
          thousandsSeparator: ".",
          decimalSeparator: ",",
          symbolOnLeft: true,
          spaceBetweenAmountAndSymbol: true
          })
          }}
          <template
            v-if="rate"
          >
            ({{ subtotalPriceUSD | currency('$', 2, {
            thousandsSeparator: ".",
            decimalSeparator: ",",
            symbolOnLeft: true,
            spaceBetweenAmountAndSymbol: true
            })
            }})
          </template>
        </strong>
      </div>
      <div class="col-3 align-self-center text-center">
        <button class="btn btn-danger btn-sm" @click="removeItem">
          <i class="fas fa-trash-alt"></i>
        </button>
      </div>
    </div>
  </li>
</template>

<script>
import Spinner from "../common/Spinner";
import ItemMixins from "./ItemMixins";
export default {
  mixins: [ItemMixins],
  props: ["cartItem"],
  components: {
    Spinner
  }
};
</script>

<style >
.font-size-up {
    font-size: 17px;
}
</style>